import { getTokenAndStorage } from 'startup';

export default function setJwt(window, { jwt }) {
  window[getTokenAndStorage(window).storage].setItem('access_token', jwt);
}